export enum SidebarState {
    Expanded = 1,
    Collapsed,
}
